/**
 * Card rules and configuration constants
 */

// Custom card rules: card numbers with copy limits exceeding 4
export const CARD_RULES = {
  'PR-036': 50,    // Exception: can have up to 50 copies
  'PR-107': 50,    // Exception: Baltan can have up to 50 copies
};

// Transcendent and Semi-Transcendent cards - shows warnings but doesn't affect copy limits
// Transcendent: Cannot be included in official/authorized tournament decks (limit: 0)
// Semi-Transcendent: May be included but only in limited quantities
// Note: 'reasonKey' is a translation key - use t(card.reasonKey) to get localized string
export const TRANSCENDENT_CARDS = {
  'BP01-022': { reasonKey: 'deckConfig.transcendent.reason', limit: 0, type: 'transcendent' },
  'BP01-026': { reasonKey: 'deckConfig.transcendent.reason', limit: 0, type: 'transcendent' },
  'PR-107': { reasonKey: 'deckConfig.semiTranscendent.reason', limit: 8, type: 'semi-transcendent' },
};

// Preloaded deck templates
// To add more decks: add an entry with a unique id, name, description, 
// representative imageUrl (first card image), and the deckCode (base64 export string)
export const PRELOAD_DECKS = [

  {
    id: 'gardeno-geed',
    name: 'BP06 Mono Geed',
    name_ja: 'ジード単',
    description: 'A Mono-Geed deck focused showcasing the latest cards from BP06.',
    description_ja: 'BP06の最新カードを活用したジード単体デッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/0b74547713e9aedd.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTE3VDEwOjMzOjE0LjQ4M1oiLCJjYXJkcyI6W3siaWQiOiI4NDMiLCJjb3VudCI6NH0seyJpZCI6IjkwMyIsImNvdW50IjozfSx7ImlkIjoiNDQyIiwiY291bnQiOjR9LHsiaWQiOiI1NCIsImNvdW50Ijo0fSx7ImlkIjoiMTI0IiwiY291bnQiOjR9LHsiaWQiOiI3NCIsImNvdW50Ijo0fSx7ImlkIjoiODM4IiwiY291bnQiOjJ9LHsiaWQiOiIxNTYiLCJjb3VudCI6M30seyJpZCI6IjkwOCIsImNvdW50IjoyfSx7ImlkIjoiNjc1IiwiY291bnQiOjN9LHsiaWQiOiIxMjciLCJjb3VudCI6NH0seyJpZCI6Ijk4MCIsImNvdW50Ijo0fSx7ImlkIjoiOTgzIiwiY291bnQiOjR9LHsiaWQiOiIxMDU4IiwiY291bnQiOjF9LHsiaWQiOiI5NzkiLCJjb3VudCI6NH1dfQ=='
  },
  {
    id: 'gardeno-z-sevenger',
    name: 'Z & Sevenger',
    name_ja: 'ゼット＆セブンガー',
    description: 'A sample deck to demonstrate how to synergize Ultraman Z with Sevenger support cards.',
    description_ja: 'ウルトラマンゼットとセブンガーのサポートカードを組み合わせたシナジーデッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/13e6983d0340641e.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIwVDAxOjI3OjMyLjU3MFoiLCJjYXJkcyI6W3siaWQiOiIxMzAiLCJjb3VudCI6NH0seyJpZCI6IjU2IiwiY291bnQiOjR9LHsiaWQiOiI2MjIiLCJjb3VudCI6NH0seyJpZCI6Ijk5MCIsImNvdW50Ijo0fSx7ImlkIjoiNjIzIiwiY291bnQiOjR9LHsiaWQiOiI2MjYiLCJjb3VudCI6NH0seyJpZCI6IjEwMTYiLCJjb3VudCI6M30seyJpZCI6IjEwMTkiLCJjb3VudCI6NH0seyJpZCI6IjEwMjIiLCJjb3VudCI6NH0seyJpZCI6IjEwMjAiLCJjb3VudCI6MX0seyJpZCI6IjE1NyIsImNvdW50IjozfSx7ImlkIjoiNTA4IiwiY291bnQiOjJ9LHsiaWQiOiI3MDAiLCJjb3VudCI6M30seyJpZCI6Ijk4NyIsImNvdW50IjoyfSx7ImlkIjoiMTM3IiwiY291bnQiOjJ9LHsiaWQiOiI2MjUiLCJjb3VudCI6Mn1dfQ=='
  },
  {
    id: 'tiga-max',
    name: 'Tiga & Max',
    name_ja: 'ティガ＆マックス',
    description: 'A dual-character deck combining Ultraman Tiga and Ultraman Max synergies.',
    description_ja: 'ウルトラマンティガとウルトラマンマックスのシナジーを活かした2キャラクターデッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/d74f5be569e39787.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIzVDA3OjE2OjI0LjUwN1oiLCJjYXJkcyI6W3siaWQiOiI5MjgiLCJjb3VudCI6NH0seyJpZCI6IjkyOSIsImNvdW50Ijo0fSx7ImlkIjoiMTYiLCJjb3VudCI6NH0seyJpZCI6Ijc2NSIsImNvdW50Ijo0fSx7ImlkIjoiNzY5IiwiY291bnQiOjR9LHsiaWQiOiI5MDEiLCJjb3VudCI6Mn0seyJpZCI6Ijk0IiwiY291bnQiOjR9LHsiaWQiOiI5NjMiLCJjb3VudCI6NH0seyJpZCI6Ijk2NiIsImNvdW50Ijo0fSx7ImlkIjoiOTY5IiwiY291bnQiOjR9LHsiaWQiOiI5NjciLCJjb3VudCI6MX0seyJpZCI6IjEwNTYiLCJjb3VudCI6M30seyJpZCI6Ijg5MSIsImNvdW50IjoyfSx7ImlkIjoiOTMiLCJjb3VudCI6NH0seyJpZCI6IjIyIiwiY291bnQiOjJ9XX0='
  },
  {
    id: 'earth-focus-blazar',
    name: 'Earth Garon Focused Blazar',
    name_ja: 'アースガロン＆ブレーザー',
    description: 'A Blazar deck focused on heavy Earth Garon support and charge usage.',
    description_ja: 'アースガロンのサポートとチャージを重視したブレーザーデッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/1014455b838598fb.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIxVDA4OjU3OjQ0Ljg0MFoiLCJjYXJkcyI6W3siaWQiOiIxMDY1IiwiY291bnQiOjR9LHsiaWQiOiIxMDI1IiwiY291bnQiOjR9LHsiaWQiOiIxMDI2IiwiY291bnQiOjR9LHsiaWQiOiIxMDI4IiwiY291bnQiOjR9LHsiaWQiOiIxMDI5IiwiY291bnQiOjR9LHsiaWQiOiIxMDMwIiwiY291bnQiOjJ9LHsiaWQiOiIxMDMxIiwiY291bnQiOjR9LHsiaWQiOiIxMDMzIiwiY291bnQiOjN9LHsiaWQiOiIxMDMyIiwiY291bnQiOjJ9LHsiaWQiOiIxMDYxIiwiY291bnQiOjN9LHsiaWQiOiIxMTQiLCJjb3VudCI6NH0seyJpZCI6IjEwMDAiLCJjb3VudCI6Mn0seyJpZCI6IjEwMDQiLCJjb3VudCI6NH0seyJpZCI6IjEwMDEiLCJjb3VudCI6NH0seyJpZCI6IjkzMiIsImNvdW50IjoyfV19'
  },
  {
    id: 'decker',
    name: 'Decker',
    name_ja: 'デッカー単',
    description: 'A mono-Decker deck showcasing BP06 Ultraman Decker across all his forms.',
    description_ja: 'BP06のウルトラマンデッカーの全形態を活かした単体デッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/478080b62e628f4e.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIyVDE4OjAyOjM1LjQ1NloiLCJjYXJkcyI6W3siaWQiOiIzMCIsImNvdW50Ijo0fSx7ImlkIjoiOTkzIiwiY291bnQiOjR9LHsiaWQiOiI4NDciLCJjb3VudCI6Mn0seyJpZCI6IjExMSIsImNvdW50Ijo0fSx7ImlkIjoiOTk0IiwiY291bnQiOjR9LHsiaWQiOiI0NTEiLCJjb3VudCI6NH0seyJpZCI6Ijk5NiIsImNvdW50IjoyfSx7ImlkIjoiMTEyIiwiY291bnQiOjJ9LHsiaWQiOiI4NTMiLCJjb3VudCI6NH0seyJpZCI6IjMxIiwiY291bnQiOjR9LHsiaWQiOiI5OTciLCJjb3VudCI6NH0seyJpZCI6IjY4MiIsImNvdW50Ijo0fSx7ImlkIjoiODU1IiwiY291bnQiOjF9LHsiaWQiOiI5MDQiLCJjb3VudCI6M30seyJpZCI6IjYzNSIsImNvdW50IjoyfSx7ImlkIjoiMTU1IiwiY291bnQiOjF9LHsiaWQiOiI1MDkiLCJjb3VudCI6MX1dfQ=='
  },
  {
    id: 'belial-darklops',
    name: 'Belial Darklops',
    name_ja: 'ベリアル＆ダークロプス',
    description: 'A terrifying kaiju deck featuring Ultraman Belial and Darklops Zero.',
    description_ja: 'ウルトラマンベリアルとダークロプスゼロを中心とした恐怖の怪獣デッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/3092b4edcef7aaaa.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIyVDE4OjI5OjM4LjI5MVoiLCJjYXJkcyI6W3siaWQiOiIxNDkiLCJjb3VudCI6NH0seyJpZCI6IjEwNDgiLCJjb3VudCI6NH0seyJpZCI6IjEwNTAiLCJjb3VudCI6NH0seyJpZCI6IjEwNDkiLCJjb3VudCI6NH0seyJpZCI6IjEwNjMiLCJjb3VudCI6NH0seyJpZCI6IjQ1NCIsImNvdW50Ijo0fSx7ImlkIjoiMTAzOSIsImNvdW50Ijo0fSx7ImlkIjoiMTA0MiIsImNvdW50Ijo0fSx7ImlkIjoiNDU4IiwiY291bnQiOjR9LHsiaWQiOiIxMDQ0IiwiY291bnQiOjN9LHsiaWQiOiI0NjIiLCJjb3VudCI6NH0seyJpZCI6IjEwNDUiLCJjb3VudCI6NH0seyJpZCI6Ijg2NyIsImNvdW50IjoyfSx7ImlkIjoiODY2IiwiY291bnQiOjF9XX0='
  },
  {
    id: 'orb',
    name: 'Orb',
    name_ja: 'オーブ単',
    description: 'A mono-Orb deck featuring Ultraman Orb newest RRR level 3.',
    description_ja: '最新のRRRレベル3を搭載したウルトラマンオーブ単体デッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/b3b14cdc2fba2114.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIzVDA0OjU5OjM5LjI0OFoiLCJjYXJkcyI6W3siaWQiOiI2NzMiLCJjb3VudCI6NH0seyJpZCI6IjQyOCIsImNvdW50Ijo0fSx7ImlkIjoiNDI5IiwiY291bnQiOjR9LHsiaWQiOiI5NzYiLCJjb3VudCI6NH0seyJpZCI6IjQyNSIsImNvdW50Ijo0fSx7ImlkIjoiOTc1IiwiY291bnQiOjR9LHsiaWQiOiI0MjIiLCJjb3VudCI6NH0seyJpZCI6IjY2OCIsImNvdW50Ijo0fSx7ImlkIjoiOTcyIiwiY291bnQiOjR9LHsiaWQiOiI2NjkiLCJjb3VudCI6NH0seyJpZCI6IjY3MSIsImNvdW50Ijo0fSx7ImlkIjoiNzAyIiwiY291bnQiOjR9LHsiaWQiOiIxMDU3IiwiY291bnQiOjJ9XX0='
  },
  {
    id: 'omega-single-friends',
    name: 'Omega (Single Meteo)',
    name_ja: 'オメガ（メテオ怪獣単体）',
    description: 'An Ultraman Omega deck built around playing Meteo Kaiju Singles for the BP06 support.',
    description_ja: 'BP06サポートを活用してメテオ怪獣を単体でプレイするオメガデッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/13110311852a9a91.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIzVDA1OjIwOjA2LjgwOVoiLCJjYXJkcyI6W3siaWQiOiIxMDYyIiwiY291bnQiOjJ9LHsiaWQiOiI1OTYiLCJjb3VudCI6NH0seyJpZCI6IjU5MyIsImNvdW50IjoxfSx7ImlkIjoiNTk0IiwiY291bnQiOjR9LHsiaWQiOiI2OTUiLCJjb3VudCI6MX0seyJpZCI6IjY5NiIsImNvdW50Ijo0fSx7ImlkIjoiODg3IiwiY291bnQiOjF9LHsiaWQiOiI4ODkiLCJjb3VudCI6NH0seyJpZCI6IjkwNSIsImNvdW50IjozfSx7ImlkIjoiNjEwIiwiY291bnQiOjR9LHsiaWQiOiI1ODkiLCJjb3VudCI6Mn0seyJpZCI6IjEwMTMiLCJjb3VudCI6M30seyJpZCI6IjYwNyIsImNvdW50Ijo0fSx7ImlkIjoiMTAxMCIsImNvdW50Ijo0fSx7ImlkIjoiNTg2IiwiY291bnQiOjJ9LHsiaWQiOiI2MDQiLCJjb3VudCI6NH0seyJpZCI6IjEwMDciLCJjb3VudCI6M31dfQ=='
  },
  {
    id: 'dyna-trigger',
    name: 'Dyna Trigger',
    name_ja: 'ダイナ＆トリガー',
    description: 'A dual-character deck combining Ultraman Dyna and Ultraman Trigger.',
    description_ja: 'ウルトラマンダイナとウルトラマントリガーを組み合わせた2キャラクターデッキ。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/4e077ac242e5e13c.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI2LTAxLTIzVDA1OjM5OjIxLjM1OFoiLCJjYXJkcyI6W3siaWQiOiIxNTgiLCJjb3VudCI6Mn0seyJpZCI6IjY5NyIsImNvdW50Ijo0fSx7ImlkIjoiMTA1NSIsImNvdW50IjoxfSx7ImlkIjoiNjMwIiwiY291bnQiOjN9LHsiaWQiOiI1OCIsImNvdW50Ijo0fSx7ImlkIjoiNTciLCJjb3VudCI6NH0seyJpZCI6IjYyOSIsImNvdW50IjoxfSx7ImlkIjoiNjMzIiwiY291bnQiOjR9LHsiaWQiOiIxNDMiLCJjb3VudCI6Mn0seyJpZCI6Ijc4MCIsImNvdW50IjoxfSx7ImlkIjoiNjAxIiwiY291bnQiOjR9LHsiaWQiOiI5NjAiLCJjb3VudCI6NH0seyJpZCI6IjU5OCIsImNvdW50IjozfSx7ImlkIjoiMjMzIiwiY291bnQiOjN9LHsiaWQiOiIyMzAiLCJjb3VudCI6NH0seyJpZCI6IjU5NyIsImNvdW50IjoyfSx7ImlkIjoiOTU3IiwiY291bnQiOjR9XX0='
  },
  {
    id: 'ud01-starter',
    name: 'Tiga Blazar Ultra Deck Demo',
    name_ja: 'ティガ＆ブレーザー ウルトラデッキ',
    description: 'A balanced Ultraman Tiga Blazar Ultra deck for beginners as a possible upgrade for your UD01 Decks.',
    description_ja: '初心者向けのバランスの取れたティガ＆ブレーザーデッキ。UD01デッキのアップグレード例。',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/f890742dcca77afa.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI1LTEyLTI5VDAyOjQxOjU5LjYwMFoiLCJjYXJkcyI6W3siaWQiOiIyNjciLCJjb3VudCI6M30seyJpZCI6IjExNCIsImNvdW50Ijo0fSx7ImlkIjoiMzYiLCJjb3VudCI6M30seyJpZCI6IjM5IiwiY291bnQiOjJ9LHsiaWQiOiI5MzEiLCJjb3VudCI6Mn0seyJpZCI6IjkzNCIsImNvdW50IjoyfSx7ImlkIjoiOTAxIiwiY291bnQiOjJ9LHsiaWQiOiI3NjUiLCJjb3VudCI6NH0seyJpZCI6Ijc2OSIsImNvdW50IjozfSx7ImlkIjoiMTYiLCJjb3VudCI6NH0seyJpZCI6IjkzIiwiY291bnQiOjR9LHsiaWQiOiI5NCIsImNvdW50Ijo0fSx7ImlkIjoiMjIiLCJjb3VudCI6MX0seyJpZCI6IjY2IiwiY291bnQiOjF9LHsiaWQiOiI5MjciLCJjb3VudCI6NH0seyJpZCI6IjkyOSIsImNvdW50IjozfSx7ImlkIjoiNjIiLCJjb3VudCI6NH1dfQ=='
  }
  // Add more decks here following the same format
];

// Chart options for deck statistics
export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        font: { size: 11 },
        padding: 10,
        usePointStyle: true,
      }
    }
  }
};

// Base bar chart options - max will be set dynamically
export const BAR_CHART_OPTIONS = {
  indexAxis: 'x',
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      max: 20, // Default, will be overridden dynamically
      ticks: { stepSize: 5 }
    }
  }
};

// Helper to get dynamic bar chart options based on max count
export const getBarChartOptions = (maxCount) => {
  let yMax = 20;
  let stepSize = 5;

  if (maxCount > 20) {
    yMax = 30;
    stepSize = 5;
  }

  return {
    ...BAR_CHART_OPTIONS,
    scales: {
      y: {
        beginAtZero: true,
        max: yMax,
        ticks: { stepSize }
      }
    }
  };
};

// Color palette for pie chart (first two match --brand and --brand-accent)
export const CHART_COLORS = [
  '#3c618a', '#7a67ba', '#dc143c', '#ff6b9d', '#ffa500',
  '#51cf66', '#339af0', '#845ef7', '#d0bfff', '#ffd43b',
  '#ff922b', '#fa5252', '#748ffc', '#b197fc', '#91a7ff'
];
